export default function ImageBackground({ children, className }) {
  const backgroundStyle = {
    backgroundImage: 'url("/Assets/Images/background.png")',
    backgroundSize: "contain",
    backgroundPosition: "center",
    height: "30vh",
    width: "100%",
  };

  return (
    <div
      style={backgroundStyle}
      className={`m-auto flex justify-center p-4 ${className} `}
    >
      {children}
    </div>
  );
}
